import Contract from "../../../../utils/contract";
import {parallel} from "../../../../utils/race-utils";
import LandAnimateOverSymbolBehaviour from "./land-animate-over-symbol-behaviour";

export class AnimateIdleSymbolBehavior extends LandAnimateOverSymbolBehaviour {
    public land(): Contract<void> {
        return new Contract((resolve) => {
            return parallel([
                           //     () => this.animate("_land", "land", true),
                             //   () => this.animate("_land_over", "land_over", true, false, false)
                            ])
                .then(() => {
                    this.animate("_idle", undefined, false, true).execute();
                    resolve(null);
                });
        });
    }

    public static() {
        super.static();
    }

    public idle() {
        // override default static() call
    }

    public dim(): Contract<void> {
        this.animations.forEach((animation) => {
            animation.tint = 0x333333;
        });

        return Contract.empty();
    }
    
    protected animate(animSuffix: string | string[], defaultAnimation?: string, autoReset: boolean = false, loop: boolean = false) {
        this.symbol.setVisible(false);
        loop = false;

        return new Contract<void>((resolve) => {
            super.animate(animSuffix, defaultAnimation, autoReset, loop).then(() => {
                this.symbol.setVisible(true);
                resolve(null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/components/matrix/symbol/behaviours/animate-idle-symbol-behavior.ts